import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../core/core.module';
import { LgvCompanyService } from '../../core/services/lgv-company.service';

@Component({
    selector: 'lgv-app-name-display',
    templateUrl: './app-name-display.component.html',
    styleUrls: ['./app-name-display.component.scss']
})
export class AppNameDisplayComponent implements OnInit {

    // just return true till we get a company that want their own name...
    get IsHomeDashboardCompany(): boolean { return true; }

    constructor(public lgvCompanySvc: LgvCompanyService) { }


    ngOnInit() {

    }
}
